import * as React from 'react';
import { connect } from 'react-redux';
import { DRIVERS_LICENCE } from '../../../routes/routes';
import './CarRisk.css';
import { postToController } from '../../../actions/apiActions';
import { navigateTo } from '../../../actions/navigationActions';
import { setCarRisk } from '../../../actions/salesActions';
import { ProgressBar, Button, Dropdown, Image } from 'react-bootstrap';

class CarRisk extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            nextDisabled: true,
            carRiskList: [],
            selectedCarRisk: '',
            selecteCarRiskDropdown: false,
            loggedIn: this.props.auth.uid ? true : false,
        };
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleCarRiskSelection = this.handleCarRiskSelection.bind(this);
        this.handleCarRiskDropdownToggle = this.handleCarRiskDropdownToggle.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.getCarRisk = this.getCarRisk.bind(this);
    }

    handleClick() {
        this.props.dispatchSetCarRisk(this.state.selectedCarRisk)
    }

    handleRedirect(nextPage: string) {
        this.props.redirectTo(nextPage);
    }

    async componentDidMount() {
        await this.getCarRisk()
    }

    async getCarRisk() {
        await postToController(this.props.dispatch, 'GetInsuranceDuration', JSON.stringify({})).then(async (response) => {
            await this.setState({ carRiskList: response });
            return true;
        })
    }

    async handleCarRiskSelection(e: any) {
        /* eslint eqeqeq: "off" */
        let maritalItem = this.state.carRiskList.filter(function (item) {
            return item.id == e
        })
        /* eslint eqeqeq: "warn" */
        await this.setState({ selectedCarRisk: maritalItem[0] });
        this.setState({ nextDisabled: maritalItem[0] === undefined });
    }

    async handleCarRiskDropdownToggle(e: any) {
        await this.setState({
            selectedCarRiskDropdown: !this.state.selectedCarRiskDropdown
        });
    }

    async handleBack(e: any) {
        this.props.redirectTo(DRIVERS_LICENCE)
    }

    public render() {
        let carRiskDrop = [];
        if (this.state.carRiskList.length > 0) {
            carRiskDrop = this.state.carRiskList.map((item) => {
                return <Dropdown.Item eventKey={item.id} key={item.id}>{item.description}</Dropdown.Item>
            });
        }
        return (
            <div className={this.state.loggedIn ? "pt-lg-5 pb-5 logged-in" : "pt-lg-5 pb-5 logged-out"}>
                <div className="col-12 mt-4 pb-4 text-lg-center text-md-center">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                        <div className="BackRectangle d-none d-lg-block d-md-block">
                                            <button onClick={this.handleBack} className="Back cursor-pointer"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></button>
                                        </div>
                                        <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                            <button onClick={this.handleBack} className="Back cursor-pointer" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></button>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={80} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="mt-5 text-center">
                                    <img src="./images/OnlineQuotation/crown-icon.png" className="img-fluid" alt="" />
                                </div>
                                <div className="ma-top-21px text-center">
                                    <p className="text-16 header-bold">Since taking out car insurance for the first time, have you ever<br className="d-none d-lg-block"/> had a break in cover that lasted for more than 30 days?</p>
                                    <p className="text-16 font-weight-500">If you haven’t had comprehensive car cover before, choose ‘not <br />currently insured’ from the list below</p>
                                </div>
                                <div className="row ma-top-30px">
                                    <div className="col-lg-12 col-md-12 col-12 p-lg-0">
                                        <Dropdown
                                            id="carRisk-select-dropdown"
                                            className="fit-full"
                                            onSelect={this.handleCarRiskSelection}
                                            onToggle={this.handleCarRiskDropdownToggle}>
                                            <Dropdown.Toggle id="dropdown-basic">
                                                <div className="row dropdown-height">
                                                    <div className="dropdown-basic-title-text col-11">
                                                        {this.state.selectedCarRisk.description}
                                                        {!this.state.selectedCarRisk &&
                                                            <p>Select insurance duration</p>
                                                        }
                                                    </div>
                                                    <Image src='Images/red-arrow-up-24-px.svg' className={this.state.selectedCarRiskDropdown ? 'visible' : 'invisible'} alt="" />
                                                    <Image src='Images/red-arrow-down-24-px.svg' className={this.state.selectedCarRiskDropdown ? 'invisible' : 'visible'} alt="" />
                                                </div>
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu id='carRiskDropDown'>
                                                {carRiskDrop}
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                    <div className="col-lg-3 col-md-3 col-xs-12 col-sm-12">
                                        <Button className="btn btn-block btn-solid-red" id="submitButton" disabled={this.state.nextDisabled} onClick={this.handleClick}>Next</Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        sales: state.sales,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        redirectTo: (des) => dispatch(navigateTo(des)),
        dispatchSetCarRisk: (carRisk: any) => dispatch(setCarRisk(carRisk))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CarRisk);